var _path, _g, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56127 15C6.57058 12.2386 8.8167 10 11.5781 10H31.77C32.3222 10 32.7684 10.4477 32.7666 11L32.6952 32.1723C32.6934 32.7246 32.2441 33.1723 31.6919 33.1723H7.50002C6.94774 33.1723 6.50153 32.7246 6.50339 32.1723L6.56127 15Z",
    fill: "url(#paint0_linear_16369_16181)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16369_16181)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.4277,
    y: 10,
    width: 30.0721,
    height: 28,
    rx: 1,
    fill: "url(#paint1_linear_16369_16181)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.3691,
    y: 12.8966,
    width: 8.73061,
    height: 8.68966,
    rx: 1,
    fill: "url(#paint2_linear_16369_16181)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0078,
    y: 13.8966,
    width: 14.551,
    height: 1.93103,
    rx: 0.5,
    fill: "url(#paint3_linear_16369_16181)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0078,
    y: 18.6552,
    width: 12.6109,
    height: 1.93103,
    rx: 0.5,
    fill: "url(#paint4_linear_16369_16181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9065 33.0816H17.7147L14.7993 28.9029H14.7443V33.0816H13.3691V26.5047H14.5793L17.4763 30.6834H17.5405V26.5047H18.9065V33.0816Z",
    fill: "url(#paint5_linear_16369_16181)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9178 26.5047H24.3734V27.6311H21.293V29.2299H24.1442V30.3563H21.293V31.9552H24.3826V33.0816H19.9178V26.5047Z",
    fill: "url(#paint6_linear_16369_16181)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9262 26.5047H26.4298L27.5483 31.1012H27.6033L28.8226 26.5047H30.1153L31.3346 31.1103H31.3896L32.5081 26.5047H34.0116L32.1139 33.0816H30.7662L29.501 28.7394H29.446L28.1717 33.0816H26.824L24.9262 26.5047Z",
    fill: "url(#paint7_linear_16369_16181)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1491 28.3851C38.1216 28.1247 38.007 27.9218 37.8053 27.7764C37.6036 27.6311 37.3362 27.5584 37.0031 27.5584C36.7739 27.5584 36.5768 27.5917 36.4118 27.6583C36.2498 27.7219 36.1261 27.8113 36.0405 27.9263C35.9549 28.0414 35.9122 28.1731 35.9122 28.3215C35.9122 28.5335 36.0084 28.703 36.2009 28.8302C36.3935 28.9574 36.6517 29.0573 36.9756 29.13L37.5715 29.2753C38.1858 29.4116 38.6702 29.6372 39.0247 29.9521C39.3822 30.264 39.561 30.6803 39.561 31.2012C39.561 31.6039 39.4586 31.9536 39.2539 32.2504C39.0491 32.5441 38.7542 32.7712 38.3692 32.9317C37.9841 33.0922 37.5257 33.1724 36.994 33.1724C36.4561 33.1724 35.9886 33.0907 35.5913 32.9272C35.1971 32.7637 34.8899 32.5229 34.6699 32.205C34.4529 31.884 34.3383 31.4919 34.3261 31.0286H35.6646C35.686 31.3526 35.8144 31.6009 36.0497 31.7735C36.288 31.943 36.5967 32.0278 36.9756 32.0278C37.214 32.0278 37.4233 31.993 37.6036 31.9234C37.7839 31.8537 37.923 31.7568 38.0208 31.6327C38.1186 31.5085 38.1675 31.3647 38.1675 31.2012C38.1675 30.9892 38.0743 30.8212 37.8878 30.697C37.7045 30.5729 37.4187 30.4623 37.0306 30.3654L36.3064 30.1928C35.1023 29.8991 34.5003 29.3026 34.5003 28.4033C34.5003 28.0096 34.6073 27.6629 34.8212 27.3631C35.0382 27.0603 35.3376 26.8271 35.7196 26.6636C36.1016 26.4971 36.5325 26.4138 37.0123 26.4138C37.4951 26.4138 37.9215 26.4971 38.2912 26.6636C38.661 26.8302 38.9483 27.0633 39.153 27.3631C39.3578 27.6599 39.4632 28.0005 39.4693 28.3851H38.1491Z",
    fill: "url(#paint8_linear_16369_16181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16369_16181",
    x: 9.92773,
    y: 9.5,
    width: 32.0723,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16369_16181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16369_16181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16369_16181",
    x1: 19.674,
    y1: 10,
    x2: 19.674,
    y2: 33.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1FF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16369_16181",
    x1: 26.4638,
    y1: 10,
    x2: 26.4638,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E47EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16369_16181",
    x1: 15.4554,
    y1: 12.7204,
    x2: 19.6664,
    y2: 21.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16369_16181",
    x1: 28.4848,
    y1: 13.8574,
    x2: 28.637,
    y2: 16.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16369_16181",
    x1: 28.0212,
    y1: 18.616,
    x2: 28.1966,
    y2: 21.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16369_16181",
    x1: 19.6278,
    y1: 26.2768,
    x2: 20.6523,
    y2: 34.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16369_16181",
    x1: 19.6278,
    y1: 26.2768,
    x2: 20.6523,
    y2: 34.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16369_16181",
    x1: 19.6278,
    y1: 26.2768,
    x2: 20.6523,
    y2: 34.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16369_16181",
    x1: 19.6278,
    y1: 26.2768,
    x2: 20.6523,
    y2: 34.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/포커뉴스.fafc9d6c96b55ad31a7603d8c368bd88.svg";
export { ForwardRef as ReactComponent };